import script from "./CatalogCategoryViewV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogCategoryViewV1.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogCategoryViewV1.vue?vue&type=style&index=0&id=1908399b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1908399b"]])

export default __exports__